import React from 'react'
import style from "./Main.module.css";
import Header from "../components/Header";


function Main() {
  return (
    <>
      <Header />
      <section id={style.main_cont} >
          <div className={style.main}>
              <ul>
                  <li>
                      <a href="https://statement.daeryunlaw.com/detective">
                          <img src="images/ccenter5.png" alt="형사 진술서" width={45} height={45}/>
                          <hr/>
                          <p>형사 진술서</p>
                          <h3>criminal</h3>
                      </a>
                  </li>
                  <li>
                      <a href="https://statement.daeryunlaw.com/divorce">
                          <img src="images/ccenter7.png" alt="이혼 진술서" width={45} height={45}/>
                          <hr/>
                          <p>이혼 진술서</p>
                          <h3>divorce</h3>
                      </a>
                  </li>
                  <li>
                      <a href="https://statement.daeryunlaw.com/compensation">
                          <img src="images/compensation.webp" alt="민사 진술서" width={45} height={45}/>
                          <hr/>
                          <p>민사 진술서</p>
                          <h3>compensation</h3>
                      </a>
                  </li>
                  <li>
                      <a href="https://statement.daeryunlaw.com/accusation">
                          <img src="images/ccenter13.webp" alt="형사 고소사건 경위확인" width={45} height={45}/>
                          <hr/>
                          <p>형사 고소사건 경위확인</p>
                          <h3>accusation</h3>
                      </a>
                  </li>
              </ul>
          </div>
      </section>
    </>
  )
}

export default Main